import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import parseUrl from 'url-parse';
import CommonChrome from '../CommonChrome';
import AccountDropdown from '../CommonChrome/components/AccountDropdown';
import { useUserContext } from '../CommonChrome/components/UserContext';
import { ProductRole } from '../../graphql/__generated__/typeDefs';
import Icon from '../../components/Icon';
import { useContext } from 'react';
import { getActivationPage } from './links/ActivationPages';
import { getDomains } from './links/getDomains';
/** Custom labels for organizations, settings, profile, and logout,
 * e.g. if the consumer has translations set up via i18next.
 * Defaults are 'My Organizations' | 'My Settings' | 'Profile' | 'Logout'.
 * */

var defaultLabels = {
  organizations: 'My Organizations',
  settings: 'My Settings',
  profile: 'Profile',
  logout: 'Log out'
};

var addOrgIdParam = function addOrgIdParam(url, id) {
  var parsedUrl = parseUrl(url, true);
  return parsedUrl.set('query', _objectSpread(_objectSpread({}, parsedUrl.query), {}, {
    swicus_org_id: id
  })).toString();
};
/**
 * Accepts a function that should return the current URL with any needed
 * transformations (e.g. removing non-SWICUS org ID from the path, moving
 * up to a list page if on a specific APM service or AO dashboard, etc.).
 * Returns a function that replaces the current SWICUS org ID in the url
 * with the new one if present, otherwise just adds the swicus_org_id param.
 */


export var orgIdToHrefFor = function orgIdToHrefFor(getCurrentUrl) {
  return function (id, currentSwicusOrgId) {
    var currentUrl = getCurrentUrl(currentSwicusOrgId);

    if (currentSwicusOrgId && currentUrl.match(currentSwicusOrgId)) {
      return currentUrl.replace(currentSwicusOrgId, id);
    }

    return addOrgIdParam(currentUrl, id);
  };
};
var orgIdToHrefDefault = orgIdToHrefFor(function () {
  return window.location.href;
});
/**
 *
 * @property {Product} currentProduct - current product. Links for organizations
 * without access to the current product will point to the home page.
 * @property {AccountMenuLabels} labels - Optional custom labels to use in place
 * of 'My Organizations', 'My Settings', 'My Profile', and 'Logout', e.g.
 * if the consumer has translations set up via i18next.
 * @property {(id: string, currentSwicusOrgId: string) => string} orgIdToHref -
 * an optional function that will accept the desired org id and the current org id
 * and return a url to use for that link in the list of organizations. Most use
 * cases will hopefully be fine with the default, which simply replaces the
 * current SWICUS org ID in the url with the new one if present, otherwise just
 * adds the swicus_org_id param. More complex use cases can use the
 * `orgIdToHrefFor` helper to apply any needed transformations (e.g. removing
 * non-SWICUS org ID from the path, moving up to a list page if on a specific
 * APM service or AO dashboard, etc.) before adding the new swicus org id.
 *
 * --
 *
 * Current properties that I hope to refactor to automatically inherit from the
 * `Navigation` ancestor via context:
 * @property {boolean} inverted - dark theme
 * @property {string} environment - staging/production/development. Controls
 * the domain used for the profile link.
 * @property {DomainOverrides} domains - optionally override the `common` domain
 * that will be used by the `Profile` link instead of using the automatic one
 * based on the `environment` prop.
 */

export var AccountMenu = function AccountMenu(_ref) {
  var environment = _ref.environment,
      _ref$domains = _ref.domains,
      domains = _ref$domains === void 0 ? {} : _ref$domains,
      currentProduct = _ref.currentProduct,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? defaultLabels : _ref$labels,
      inverted = _ref.inverted,
      _ref$orgIdToHref = _ref.orgIdToHref,
      orgIdToHref = _ref$orgIdToHref === void 0 ? orgIdToHrefDefault : _ref$orgIdToHref;
  var finalDomains = getDomains(environment, domains);

  var _useUserContext = useUserContext(),
      loading = _useUserContext.loading,
      user = _useUserContext.user,
      currentOrganization = _useUserContext.currentOrganization,
      _useUserContext$organ = _useUserContext.organizations,
      organizations = _useUserContext$organ === void 0 ? [] : _useUserContext$organ;

  var activeKey = useContext(CommonChrome.Context).activeKey;

  if (loading) {
    return null;
  }

  if (!currentOrganization || !user) {
    // If we weren't able to properly load the full context, at least
    // show a fallback with a logout link
    return /*#__PURE__*/React.createElement(AccountDropdown, {
      email: "",
      userName: user ? getUserName(user) : '',
      organization: currentOrganization || {
        name: ' '
      },
      inverted: inverted,
      unifiedError: true
    }, /*#__PURE__*/React.createElement(CommonChrome.NavMenuItem, {
      href: "".concat(finalDomains.common, "/common/logout")
    }, labels.logout));
  }

  return /*#__PURE__*/React.createElement(AccountDropdown, {
    email: user.email,
    userName: getUserName(user),
    organization: currentOrganization,
    inverted: inverted,
    unified: true
  }, /*#__PURE__*/React.createElement(CommonChrome.NavMenuHeading, null, labels.organizations), organizations.map(function (organization) {
    var href = !currentProduct || orgHasProductAccess(organization, currentProduct) ? orgIdToHref(organization.id, currentOrganization.id) : getActivationPage(activeKey || '', {
      product: currentProduct,
      domains: finalDomains,
      orgId: organization.id
    });
    return /*#__PURE__*/React.createElement(CommonChrome.AccountMenuItem, {
      key: organization.id,
      organization: organization,
      isActive: organization.id === currentOrganization.id,
      href: href,
      "data-qa": "nav-switch-to-org-".concat(organization.id)
    });
  }), /*#__PURE__*/React.createElement(CommonChrome.NavMenuDivider, null), /*#__PURE__*/React.createElement(CommonChrome.NavMenuHeading, null, labels.settings), /*#__PURE__*/React.createElement(CommonChrome.NavMenuItem, {
    href: "".concat(finalDomains.common, "/settings/profile?swicus_org_id=").concat(currentOrganization.id),
    newTab: true
  }, labels.profile, /*#__PURE__*/React.createElement(Icon, {
    name: "external-link-small"
  })), /*#__PURE__*/React.createElement(CommonChrome.NavMenuDivider, null), /*#__PURE__*/React.createElement(CommonChrome.NavMenuItem, {
    href: "".concat(finalDomains.common, "/common/logout")
  }, labels.logout));
};
export default AccountMenu;

function getUserName(user) {
  var firstName = (user === null || user === void 0 ? void 0 : user.firstName) || '';
  var lastName = (user === null || user === void 0 ? void 0 : user.lastName) || '';
  return "".concat(firstName, " ").concat(lastName).trim();
}

function orgHasProductAccess(organization, currentProduct) {
  if (!currentProduct) return true;
  return organization.products.some(function (product) {
    return product.activated && product.name === currentProduct && product.productRole !== ProductRole.NoAccess;
  });
}